export default __webpack_public_path__ + "static/media/git.1ff6d964.png";